import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginationParameters, AccountsResponse, AccountsRequest, AccountsItem } from './dto/accounts';
import { Accounts, userManagementUrl } from '../../../../../constants';
import { IPaginationResponse } from '../../../../../common/core/data-access/pagination/interfaces/pagination-response.interface';
import { IAccount } from '../../../../../common/user-management/system-management/accounts/dtos/responses/accounts-list-response';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  collectionUrl: string = `${userManagementUrl}/${Accounts}`;

  constructor(private http: HttpClient) {}

  getAll(params?: PaginationParameters): Observable<IPaginationResponse<IAccount>> {
    let paramsItem = new HttpParams();

    // Loop through the parameters and append them if defined
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          paramsItem = paramsItem.append(this.mapParamKey(key), value);
        }
      });
    }

    // Return the HTTP GET call with the expected response type
    return this.http.get<IPaginationResponse<IAccount>>(`${this.collectionUrl}`, { params: paramsItem });
  }
  // Helper method to map parameter keys if needed (optional)
  private mapParamKey(key: string): string {
    const map: { [key: string]: string } = {
      sortColumn: 'SortColumn',
      sortOrder: 'SortOrder',
      searchField: 'SearchField',
      SearchKeyword: 'SearchKeyword',
      page: 'Page',
      pageSize: 'PageSize',
      order: 'Order',
      orderBy: 'OrderBy'
    };
    return map[key] || key;
  }

  // Create a new resource (POST)
  async create(request: AccountsRequest): Promise<Observable<AccountsItem>> {
    return await this.http.post<AccountsItem>(`${this.collectionUrl}`, request);
  }

  // Update a resource (PUT)
  async update(request: AccountsRequest, id: number | string): Promise<Observable<AccountsItem>> {
    return await this.http.patch<AccountsItem>(`${this.collectionUrl}/${id}`, request);
  }

  // Get a single resource by ID (GET)
  // getById(id: string): Observable<TResponse> {
  //   return this.http.get<TResponse>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }

  // Delete a single resource by ID (DELETE)
  // delete(id: string): Observable<void> {
  //   return this.http.delete<void>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }
}
